import { useLayoutEffect, useState } from "react";
export const getAllowedViews = ({ macroProgressViews, hasTargets, }) => {
    let modes = [];
    if (macroProgressViews === "all") {
        if (hasTargets) {
            modes = [...modes, "HasTargets_ShowNumbers", "HasTargets_HideNumbers", "NoTargets_HideNumbers"];
        }
        else {
            modes = [...modes, "NoTargets_ShowNumbers", "NoTargets_HideNumbers"];
        }
    }
    else if (macroProgressViews === "hideNumbers") {
        if (hasTargets) {
            modes = [...modes, "HasTargets_HideNumbers", "NoTargets_HideNumbers"];
        }
        else {
            modes = [...modes, "NoTargets_HideNumbers"];
        }
    }
    else {
        //"none" case. No available displays.
    }
    return modes;
};
export const useProgressViews = ({ macroProgressViews, hasTargets, additionalModes = [], additionalModesFirst = false, }) => {
    const [modeIndex, setModeIndex] = useState(0);
    const [allowedModes, setAllowedModes] = useState(getAllowedViews({
        macroProgressViews,
        hasTargets,
    }));
    const allModes = additionalModesFirst ? [...additionalModes, ...allowedModes] : [...allowedModes, ...additionalModes];
    const mode = allModes[modeIndex];
    useLayoutEffect(() => {
        setModeIndex(0);
        setAllowedModes(getAllowedViews({
            macroProgressViews,
            hasTargets,
        }));
    }, [macroProgressViews, hasTargets, setModeIndex]);
    const onChangeMode = () => {
        setModeIndex((modeIndex + 1) % allModes.length);
    };
    return {
        mode,
        onChangeMode,
    };
};
//# sourceMappingURL=hooks.js.map